import React, { useState, useEffect } from 'react';

export default function SelectBox(props) {
    const [options, setOptions] = React.useState([]);
    const [selected, setSelected] = React.useState("");

    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    useEffect(() => {
        const fetchData = async () => {
            setOptions(props.items);
            setSelected(props.value);
        };
        fetchData();
    }, [props.items]);

    const handleChange = (event) => {
        props.handleSelectChange(event.target.value);
        setSelected(event.target.value);
    };
    
    return (
        <>
            <select className={props.className} name={props.name} id={props.id} value={selected == null ? '' : selected} onChange={handleChange}>
                <option key="" value="">{props.default}</option>
                {
                    options.map(row => (
                        <option key={row.value} value={row.value}>{row.text}</option>
                    ))
                }
            </select>
        </>
    );
}
